// extracted by mini-css-extract-plugin
export var boxItems = "_2e-1";
export var boxItemsLg = "_2e-2";
export var button = "_2e-7";
export var buttonHoverless = "_2e-9";
export var buttonLg = "_2e-8";
export var filterGroupBox = "_2e-0";
export var icon = "_2e-3";
export var iconSecondary = "_2e-6";
export var iconWrapper = "_2e-4";
export var iconWrapperLg = "_2e-5";
export var truncatedLabel = "_2e-a";